import { render, staticRenderFns } from "./keywordeditor.vue?vue&type=template&id=0f2a7300"
import script from "./keywordeditor.vue?vue&type=script&lang=ts"
export * from "./keywordeditor.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports